// removed by extract-text-webpack-plugin
module.exports = {"select":"styles__select___3ZOF-","icon_arrow":"styles__icon_arrow___rraIW","select_container":"styles__select_container___3ywiw","legend_select":"styles__legend_select___2kBuY","option_style":"styles__option_style___352es"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FixedVoice/components/Inputs/SelectBoxLabel/styles.css
// module id = 3215
// module chunks = 0